 

// import React, { useState, useEffect } from 'react';
// import {
//   Pane,
//   Heading,
//   Button,
//   TextInputField,
//   Text,
//   toaster,
//   Spinner,
//   Table,
//   Select,
// } from 'evergreen-ui';
// import { useNavigate } from 'react-router-dom';
// import useStore from '../appservices/store';
// import { firestore } from '../appservices/firebase';
// import { doc, setDoc, collection, addDoc, getDocs } from 'firebase/firestore';

// const Onboard = () => {
//   const { user } = useStore();
//   const [loading, setLoading] = useState(false);
//   const [email, setEmail] = useState(user ? user.email : '');
//   const [displayName, setDisplayName] = useState(user ? user.displayName : '');
//   const [isCompleted, setIsCompleted] = useState(false);
//   const [newEmployeeEmail, setNewEmployeeEmail] = useState('');
//   const [newEmployeeName, setNewEmployeeName] = useState('');
//   const [newEmployeeRole, setNewEmployeeRole] = useState(3); // Default to Basic
//   const [employeeList, setEmployeeList] = useState([]);
//   const navigate = useNavigate();

//   useEffect(() => {
//     if (user) {
//       registerMicrosoftBusiness(); // Automatically register user when component loads
//       fetchEmployeeList();
//     }
//   }, [user]);

//   const fetchEmployeeList = async () => {
//     try {
//       const querySnapshot = await getDocs(collection(firestore, `businesses/${user.uid}/employees`));
//       const employees = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
//       setEmployeeList(employees);
//     } catch (error) {
//       console.error('Error fetching employees:', error);
//       toaster.danger('Failed to load employees.');
//     }
//   };

//   const handleGmailIntegration = async () => {
//     setLoading(true);
//     try {
//       const response = await fetch(`https://api-gmg22qjzza-ue.a.run.app/gmail/authenticate?uid=${user.uid}`);
//       const data = await response.json();
//       if (data.authUrl) {
//         window.location.href = data.authUrl;
//       } else {
//         throw new Error('Failed to initiate Gmail authentication');
//       }
//     } catch (error) {
//       console.error('Error integrating email:', error);
//       toaster.danger('Failed to integrate email.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const addEmployee = async () => {
//     if (!newEmployeeEmail || !newEmployeeName) {
//       toaster.warning('Please provide employee email and name.');
//       return;
//     }

//     try {
//       setLoading(true);
//       const employeeRef = collection(firestore, `businesses/${user.uid}/employees`);
//       await addDoc(employeeRef, {
//         email: newEmployeeEmail,
//         name: newEmployeeName,
//         permissionStatus: newEmployeeRole,
//       });
//       toaster.success('Employee added successfully.');
//       setNewEmployeeEmail('');
//       setNewEmployeeName('');
//       setNewEmployeeRole(3); // Reset to Basic
//       fetchEmployeeList(); // Refresh employee list
//     } catch (error) {
//       console.error('Error adding employee:', error);
//       toaster.danger('Failed to add employee.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const registerMicrosoftBusiness = async () => {
//     try {
//       setLoading(true);
  
//       // Use default values with || if fields are missing from user data
//       const payload = {
//         email: user.email || "eilufoye@gmail.com",
//         displayName: user.displayName || "Enoch Ilufoye",
//         firstName: user.firstName || "Enoch",
//         lastName: user.lastName || "Ilufoye",
//         businessName: user.businessName || "Konstant AI",
//         businessEmail: user.businessEmail || "enoch@konstantai.com",
//         uid: user.uid || `uid-${Math.random().toString(36).substr(2, 9)}`,  // Generates a random UID if not provided
//         meta: { ...user }  // Include additional user data in meta
//       };
  
//       const response = await fetch('https://aiit-gmg22qjzza-ue.a.run.app/onboard_new_business', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(payload),
//       });
  
//       if (!response.ok) {
//         throw new Error('Failed to register Microsoft business account');
//       }
  
//       const data = await response.json();
//       console.log('Microsoft Business Registration Response:', data);
//       toaster.success('Microsoft business account registered successfully.');
//     } catch (error) {
//       console.error('Error registering Microsoft business account:', error);
//       toaster.danger('Failed to register Microsoft business account.');
//     } finally {
//       setLoading(false);
//     }
//   };
  
//   const handleOnboardComplete = async () => {
//     setLoading(true);
//     try {
//       // Mark onboarding as complete in Firestore
//       const userDocRef = doc(firestore, `users/${user.uid}`);
//       await setDoc(userDocRef, { onboardComplete: true }, { merge: true });
      
//       setIsCompleted(true);
//       toaster.success('Onboarding complete.');
//       navigate('/dashboard');
//     } catch (error) {
//       console.error('Error marking onboarding complete:', error);
//       toaster.danger('Failed to complete onboarding.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Pane display="flex" justifyContent="center" alignItems="center" height="100vh">
//       <Pane width={500} padding={16} borderRadius={8} elevation={2}>
//         <Heading size={600} marginBottom={24}>Welcome to Konstant</Heading>
        
//         {!isCompleted ? (
//           <Pane>
//             <Text marginBottom={16}>Integrate your email and add employees to your business account.</Text>
            
//             {/* <TextInputField
//               label="Business Owner Email"
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//               disabled
//             />
//             <TextInputField
//               label="Business Owner Display Name"
//               value={displayName}
//               onChange={(e) => setDisplayName(e.target.value)}
//               disabled
//             />

//             {loading ? (
//               <Spinner />
//             ) : (
//               <Button appearance="primary" onClick={handleGmailIntegration} marginBottom={24}>
//                 Integrate Gmail
//               </Button>
//             )} */}

//             <Heading size={500} marginTop={24} marginBottom={8}>Add New Employee</Heading>
//             <Pane>
//               <TextInputField
//                 label="Employee Name"
//                 value={newEmployeeName}
//                 onChange={(e) => setNewEmployeeName(e.target.value)}
//                 placeholder="Enter employee name"
//                 marginBottom={16}
//               />
//               <TextInputField
//                 label="Employee Email"
//                 value={newEmployeeEmail}
//                 onChange={(e) => setNewEmployeeEmail(e.target.value)}
//                 placeholder="Enter employee email"
//                 marginBottom={16}
//               />
//               <Select
//                 width="100%"
//                 value={newEmployeeRole}
//                 onChange={(e) => setNewEmployeeRole(parseInt(e.target.value))}
//                 marginBottom={16}
//               >
//                 <option value={0}>Owner</option>
//                 <option value={1}>IT Admin</option>
//                 <option value={2}>IT Support</option>
//                 <option value={3}>Basic</option>
//               </Select>
//               <Button appearance="primary" onClick={addEmployee} marginBottom={24}>
//                 Add Employee
//               </Button>
//             </Pane>

//             <Heading size={500} marginTop={24} marginBottom={8}>Employee List</Heading>
//             <Table>
//               <Table.Head>
//                 <Table.TextHeaderCell>Name</Table.TextHeaderCell>
//                 <Table.TextHeaderCell>Email</Table.TextHeaderCell>
//                 <Table.TextHeaderCell>Role</Table.TextHeaderCell>
//               </Table.Head>
//               <Table.Body>
//                 {employeeList.map((employee) => (
//                   <Table.Row key={employee.id}>
//                     <Table.TextCell>{employee.name}</Table.TextCell>
//                     <Table.TextCell>{employee.email}</Table.TextCell>
//                     <Table.TextCell>{['Owner', 'IT Admin', 'IT Support', 'Basic'][employee.permissionStatus]}</Table.TextCell>
//                   </Table.Row>
//                 ))}
//               </Table.Body>
//             </Table>

//             <Button appearance="primary" marginTop={24} onClick={handleOnboardComplete}>
//               Complete Onboarding
//             </Button>
//           </Pane>
//         ) : (
//           <Pane>
//             <Text marginBottom={16}>Onboarding complete! Your email and employees are set up.</Text>
//             <Button appearance="primary" onClick={() => navigate('/dashboard')}>
//               Go to Dashboard
//             </Button>
//           </Pane>
//         )}
//       </Pane>
//     </Pane>
//   );
// };

// export default Onboard;
import React, { useState, useEffect } from 'react';
import {
  Pane,
  Heading,
  Button,
  TextInputField,
  Text,
  toaster,
  Spinner,
  Table,
  Select,
} from 'evergreen-ui';
import { useNavigate } from 'react-router-dom';
import useStore from '../appservices/store';
import { firestore } from '../appservices/firebase';
import { doc, setDoc, collection, addDoc, getDocs } from 'firebase/firestore';

const Onboard = () => {
  const { user } = useStore();
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState(1); // Track the current step in the onboarding process
  const [isCompleted, setIsCompleted] = useState(false);

  // Employee-related states
  const [newEmployeeEmail, setNewEmployeeEmail] = useState('');
  const [newEmployeeName, setNewEmployeeName] = useState('');
  const [newEmployeeRole, setNewEmployeeRole] = useState(3); // Default to Basic
  const [employeeList, setEmployeeList] = useState([]);

  // Product-related states for Step 2
  const [productName, setProductName] = useState('');
  const [productDescription, setProductDescription] = useState('');
  const [productList, setProductList] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      registerMicrosoftBusiness(); // Automatically register user when component loads
      fetchEmployeeList();
    }
  }, [user]);

  const fetchEmployeeList = async () => {
    try {
      const querySnapshot = await getDocs(collection(firestore, `businesses/${user.uid}/Personnel`));
      const employees = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setEmployeeList(employees);
    } catch (error) {
      console.error('Error fetching employees:', error);
      toaster.danger('Failed to load employees.');
    }
  };



  const registerMicrosoftBusiness = async () => {
    try {
      setLoading(true);
  
      // Use default values with || if fields are missing from user data
      const payload = {
        email: user.email || "eilufoye@gmail.com",
        displayName: user.displayName || "Enoch Ilufoye",
        firstName: user.firstName || "Enoch",
        lastName: user.lastName || "Ilufoye",
        businessName: user.businessName || "Konstant AI",
        businessEmail: user.businessEmail || "enoch@konstantai.com",
        uid: user.uid || `uid-${Math.random().toString(36).substr(2, 9)}`,  // Generates a random UID if not provided
        meta: { ...user }  // Include additional user data in meta
      };
  
      const response = await fetch('https://aiit-gmg22qjzza-ue.a.run.app/onboard_new_business', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });
  
      if (!response.ok) {
        throw new Error('Failed to register Microsoft business account');
      }
  
      const data = await response.json();
      console.log('Microsoft Business Registration Response:', data);
      toaster.success('Microsoft business account registered successfully.');
    } catch (error) {
      console.error('Error registering Microsoft business account:', error);
      toaster.danger('Failed to register Microsoft business account.');
    } finally {
      setLoading(false);
    }
  };

  const addEmployee = async () => {
    if (!newEmployeeEmail || !newEmployeeName) {
      toaster.warning('Please provide employee email and name.');
      return;
    }

    try {
      setLoading(true);
      const employeeRef = collection(firestore, `businesses/${user.uid}/personnel`);
      await addDoc(employeeRef, {
        email: newEmployeeEmail,
        name: newEmployeeName,
        permissionStatus: newEmployeeRole,
      });
      toaster.success('Employee added successfully.');
      setNewEmployeeEmail('');
      setNewEmployeeName('');
      setNewEmployeeRole(3); // Reset to Basic
      fetchEmployeeList(); // Refresh employee list
    } catch (error) {
      console.error('Error adding employee:', error);
      toaster.danger('Failed to add employee.');
    } finally {
      setLoading(false);
    }
  };

  const addProduct = async () => {
    if (!productName) {
      toaster.warning('Please provide a product name.');
      return;
    }

    try {
      setLoading(true);
      const productRef = collection(firestore, `businesses/${user.uid}/products`);
      await addDoc(productRef, {
        name: productName,
        description: productDescription,
      });
      toaster.success('Product added successfully.');
      setProductName('');
      setProductDescription('');
      setProductList([...productList, { name: productName, description: productDescription }]);
    } catch (error) {
      console.error('Error adding product:', error);
      toaster.danger('Failed to add product.');
    } finally {
      setLoading(false);
    }
  };

  const handleOnboardComplete = async () => {
    setLoading(true);
    try {
      // Mark onboarding as complete in Firestore
      const userDocRef = doc(firestore, `Users/${user.uid}`);
      await setDoc(userDocRef, { onboardComplete: true }, { merge: true });
      
      setIsCompleted(true);
      toaster.success('Onboarding complete.');
      navigate('/dashboard');
    } catch (error) {
      console.error('Error marking onboarding complete:', error);
      toaster.danger('Failed to complete onboarding.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Pane display="flex" justifyContent="center" alignItems="center" height="100vh">
      <Pane width={500} padding={16} borderRadius={8} elevation={2}>
        <Heading size={600} marginBottom={24}>Welcome to Konstant</Heading>

        {!isCompleted && (
          <Pane>
            {step === 1 && (
              <Pane>
                <Text marginBottom={16}>Step 1: Add employees to your business account.</Text>
                
                <TextInputField
                  label="Employee Name"
                  value={newEmployeeName}
                  onChange={(e) => setNewEmployeeName(e.target.value)}
                  placeholder="Enter employee name"
                  marginBottom={16}
                />
                <TextInputField
                  label="Employee Email"
                  value={newEmployeeEmail}
                  onChange={(e) => setNewEmployeeEmail(e.target.value)}
                  placeholder="Enter employee email"
                  marginBottom={16}
                />
                <Select
                  width="100%"
                  value={newEmployeeRole}
                  onChange={(e) => setNewEmployeeRole(parseInt(e.target.value))}
                  marginBottom={16}
                >
                  <option value={0}>Owner</option>
                  <option value={1}>IT Admin</option>
                  <option value={2}>IT Support</option>
                  <option value={3}>Basic</option>
                </Select>
                <Button appearance="primary" onClick={addEmployee} marginBottom={16}>
                  Add Employee
                </Button>

                <Heading size={500} marginTop={24} marginBottom={8}>Employee List</Heading>
                <Table>
                  <Table.Head>
                    <Table.TextHeaderCell>Name</Table.TextHeaderCell>
                    <Table.TextHeaderCell>Email</Table.TextHeaderCell>
                    <Table.TextHeaderCell>Role</Table.TextHeaderCell>
                  </Table.Head>
                  <Table.Body>
                    {employeeList.map((employee) => (
                      <Table.Row key={employee.id}>
                        <Table.TextCell>{employee.name}</Table.TextCell>
                        <Table.TextCell>{employee.email}</Table.TextCell>
                        <Table.TextCell>{['Owner', 'IT Admin', 'IT Support', 'Basic'][employee.permissionStatus]}</Table.TextCell>
                      </Table.Row>
                    ))}
                  </Table.Body>
                </Table>

                <Pane display="flex" justifyContent="space-between" marginTop={24}>
                  <Button appearance="primary" onClick={() => setStep(2)}>
                    Next: Add Products
                  </Button>
                </Pane>
              </Pane>
            )}

            {step === 2 && (
              <Pane>
                <Text marginBottom={16}>Step 2: Add products for your business.</Text>
                
                <TextInputField
                  label="Product Name"
                  value={productName}
                  onChange={(e) => setProductName(e.target.value)}
                  placeholder="Enter product name"
                  marginBottom={16}
                />
                <TextInputField
                  label="Product Description"
                  value={productDescription}
                  onChange={(e) => setProductDescription(e.target.value)}
                  placeholder="Enter product description"
                  marginBottom={16}
                />
                <Button appearance="primary" onClick={addProduct} marginBottom={16}>
                  Add Product
                </Button>

                <Heading size={500} marginTop={24} marginBottom={8}>Product List</Heading>
                <Table>
                  <Table.Head>
                    <Table.TextHeaderCell>Product Name</Table.TextHeaderCell>
                    <Table.TextHeaderCell>Description</Table.TextHeaderCell>
                  </Table.Head>
                  <Table.Body>
                    {productList.map((product, index) => (
                      <Table.Row key={index}>
                        <Table.TextCell>{product.name}</Table.TextCell>
                        <Table.TextCell>{product.description}</Table.TextCell>
                      </Table.Row>
                    ))}
                  </Table.Body>
                </Table>

                <Pane display="flex" justifyContent="space-between" marginTop={24}>
                  <Button appearance="default" onClick={() => setStep(1)}>
                    Back to Add Employees
                  </Button>
                  <Button appearance="primary" onClick={handleOnboardComplete}>
                    Complete Onboarding
                  </Button>
                </Pane>
              </Pane>
            )}
          </Pane>
        )}

        {isCompleted && (
          <Pane>
            <Text marginBottom={16}>Onboarding complete! Your email, employees, and products are set up.</Text>
            <Button appearance="primary" onClick={() => navigate('/dashboard')}>
              Go to Dashboard
            </Button>
          </Pane>
        )}
      </Pane>
    </Pane>
  );
};

export default Onboard;
